/* eslint-disable import/no-named-as-default-member */
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

const supportedLanguages = {
  Arabic: 'ar',
  English: 'en',
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: ['common'],
    defaultNS: 'common',
    fallbackLng: 'en',
    pluralSeparator: '>',
    lng: 'en',
    supportedLngs: Object.values(supportedLanguages),
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });
